import { toast } from 'react-toastify';
import { usersApi } from 'entities/users';

const uploadShopDotsExcelApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadShopDotsListExcel: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        formData.append('country_id', data.country_id);
        formData.append('file', data.file);
        return {
          url: '/sales-point/admin/sales-point/admin/sales-points/download',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error) => {
        const error_message = (error as any)?.data.detail[0].msg;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно загрузили файл', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'Users' }];
      },
    }),
    confirmUploadShopDotsListExcel: builder.mutation({
      query: (data) => ({
        url: '/sales-point/admin/sales-point/admin/sales-points/create',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error) => {
        const error_message = (error as any)?.data.detail[0].msg;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно загрузили торговые точки', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'Users' }];
      },
    }),
  }),
});

export const { useUploadShopDotsListExcelMutation, useConfirmUploadShopDotsListExcelMutation } = uploadShopDotsExcelApi;
